<div id="tree" class="withSpace">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <!-- This is the tree node template for leaf nodes -->
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
            <mat-icon class="mat-icon-rtl-mirror" matTreeNodeToggle>
                chevron_right
            </mat-icon>

            <span matTreeNodeToggle [matTooltip]="node.label">{{getShortVersion(node)}}</span>
            <span matTreeNodeToggle [matTooltip]="node.label" class="italic"> [ {{node.type}} ]</span>

            <div class="floatRight">
                <button (click)="edit(node.id)"><mat-icon>edit</mat-icon></button>
                <button (click)="delete(node.id)"><mat-icon>delete</mat-icon></button>
                <button (click)="goUp(node.id)"><mat-icon>arrow_circle_up</mat-icon></button>
                <button (click)="goDown(node.id)"><mat-icon>arrow_circle_down</mat-icon></button>
            </div>
        </mat-tree-node>

        <!-- This is the tree node template for expandable nodes -->
        <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
            <mat-icon class="mat-icon-rtl-mirror" matTreeNodeToggle [matTooltip]="treeControl.isExpanded(node) ? 'Collapse this node' : 'Expand this node'">
                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
            <span matTreeNodeToggle [matTooltip]="node.label">{{getShortVersion(node)}}</span>
            <span matTreeNodeToggle [matTooltip]="node.label" class="italic"> [ {{node.type}} ]</span>

            <div class="floatRight">
                <button (click)="edit(node.id)"><mat-icon>edit</mat-icon></button>
                <button (click)="delete(node.id)"><mat-icon>delete</mat-icon></button>
                <button (click)="goUp(node.id)"><mat-icon>arrow_circle_up</mat-icon></button>
                <button (click)="goDown(node.id)"><mat-icon>arrow_circle_down</mat-icon></button>
            </div>
        </mat-tree-node>
    </mat-tree>
</div>
